//import { useState } from "react";
import SampleSelection90daysController from "./SampleSelection90daysController";
//import Select from "react-select";
import {
  Box,
  Card,
  CircularProgress,
  Grid,
  Skeleton,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";

function SampleSelection90days() {
  const {
    barcodeData,
    monthList,
    updateQuantity,
    submitSampleRequest,
    openRemarkDialog,
    setOpenRemarkDialog,
    remark,
    setRemark,
    submitRemark,
    remarkError,
    openReportDialog,
    setOpenReportDialog,
    reportData,
    financialYears,
    getMonthYearWiseData,
    loadingInlineReports,
    loadingReportDialog
  } = SampleSelection90daysController();

  const shouldRenderTable = barcodeData && barcodeData.length > 0;
  const toShortFY = (fy) => {
    const v = String(fy || "").trim();
    const m = v.match(/^(\d{4})\s*-\s*(\d{4})$/);
    if (m) return `${m[1].slice(2)}-${m[2].slice(2)}`;
    return v;
  };

  return (
    <div className="bg" style={{ display: "block" }}>
      <div className="cutrange">
        <span className="font20">SAMPLE SELECTION SALES PLANNING</span>
      </div>

      {shouldRenderTable && (
        <Box sx={{ width: "100%", mb: 2 }}>
          <Grid container spacing={0.5}>
            {barcodeData.map((item, idx) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={item.id ?? idx}>
                <Card
                  sx={{
                    margin: 0.5,
                    p: 0.8,
                    borderRadius: 2,
                    border: "1px solid #e5e7eb",
                    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
                    boxShadow: "0 8px 22px rgba(15,23,42,0.08)",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 14px 30px rgba(15,23,42,0.14)"
                    }
                  }}
                >

                  {/* DESCRIPTION */}
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    {/* <Typography variant="h5" sx={{ color: "grey", mr: 1 }}>
                      Description-
                    </Typography> */}
                    <Typography variant="h5" sx={{ color: "black" }}>
                      {item.materialDesc || "-"}
                    </Typography>
                  </Box>

                  {(() => {
                    const headerMonth = monthList?.[0]?.month || "";
                    const headerData = headerMonth
                      ? getMonthYearWiseData(item, headerMonth)
                      : { currentFY: "Current FY", previousFY: "Previous FY" };

                    return (
                      <>
                        <Box
                          sx={{
                            mt: 1,
                            mb: 0.6,
                            p: 1,
                            borderRadius: 2,
                            backgroundColor: "#eef2f7",
                            border: "1px solid #e5e7eb",
                            display: "grid",
                            gridTemplateColumns: "30% 28% 21% 21%",
                            alignItems: "center"
                          }}
                        >
                          <Typography variant="caption" sx={{ fontWeight: 600, color: "#111827" }}>
                            Month
                          </Typography>
                          <Typography variant="caption" sx={{ fontWeight: 600, color: "#111827", textAlign: "center" }}>
                            Qty
                          </Typography>
                          <Typography variant="caption" sx={{ fontWeight: 600, color: "#111827", textAlign: "center" }}>
                           
                            {`${toShortFY(headerData.currentFY)}`}
                            <br/>
                            {'Qty(Mtr)'}

                          </Typography>
                          <Typography variant="caption" sx={{ fontWeight: 600, color: "#111827", textAlign: "center" }}>
                            
                            {`${toShortFY(headerData.previousFY)}`}
                            <br/>
                            {'Qty(Mtr)'}
                          </Typography>
                        </Box>

                        {/* DYNAMIC MONTHS */}
                        {monthList.map((monthObj) => {
                          const key = `${monthObj.month}_${monthObj.year}`;
                          const monthWiseData = getMonthYearWiseData(item, monthObj.month);
                          return (
                            <Box
                              key={key}
                              sx={{
                                mt: 0.8,
                                p: 1,
                                borderRadius: 2,
                                backgroundColor: "#ffffff",
                                border: "1px solid #eef2f7",
                                display: "grid",
                                gridTemplateColumns: "30% 28% 21% 21%",
                                alignItems: "center",
                                columnGap: 0.4
                              }}
                            >
                              <Typography variant="body2" sx={{ color: "#111827", fontWeight: 500 }}>
                                {monthObj.month}
                              </Typography>

                              <TextField
                                placeholder="Qty"
                                type="text"
                                variant="outlined"
                                size="medium"
                                fullWidth
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f9fafb",
                                    borderRadius: "10px"
                                  }
                                }}
                                value={item.months?.[key] ?? ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    updateQuantity(item.id, key, value);
                                  }
                                }}
                                inputProps={{
                                  inputMode: "numeric"
                                }}
                              />

                              {loadingInlineReports ? (
                                <>
                                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.4 }}>
                                    <Skeleton variant="text" width={34} height={22} />
                                    <Skeleton variant="text" width={42} height={16} />
                                  </Box>
                                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.4 }}>
                                    <Skeleton variant="text" width={34} height={22} />
                                    <Skeleton variant="text" width={42} height={16} />
                                  </Box>
                                </>
                              ) : (
                                <>
                                  <Typography variant="body2" sx={{ textAlign: "center", color: "#374151", fontWeight: 700 }}>
                                    {monthWiseData.currentQty}
                                    <br />
                                    <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: 500 }}>
                                      ({monthWiseData.currentFYMonth})
                                    </span>
                                  </Typography>
                                  <Typography variant="body2" sx={{ textAlign: "center", color: "#374151", fontWeight: 700 }}>
                                    {monthWiseData.previousQty}
                                    <br />
                                    <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: 500 }}>
                                      ({monthWiseData.previousFYMonth})
                                    </span>
                                  </Typography>
                                </>
                              )}
                            </Box>
                          );
                        })}
                      </>
                    );
                  })()}
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* FOOTER BUTTONS */}
      <div className="footer-button">
        <button style={{ marginRight: "15px" }}>Cancel</button>
        <button
          style={{ marginRight: "15px", opacity: loadingInlineReports ? 0.7 : 1, cursor: loadingInlineReports ? "not-allowed" : "pointer" }}
          onClick={submitSampleRequest}
          disabled={loadingInlineReports}
        >
          {loadingInlineReports ? "Loading..." : "Proceed"}
        </button>
      </div>

      {/* REMARK DIALOG */}
      <Dialog
        open={openRemarkDialog}
        onClose={() => setOpenRemarkDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Remarks
          <IconButton onClick={() => setOpenRemarkDialog(false)}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <textarea
            type="text"
            name="remark"
            value={remark}
            className="form-control inp_text"
            id="remark"
            rows={7}
            cols={50}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="Write Remark Here..."
            autoFocus
          />
          {remarkError && (
            <Typography
              variant="body2"
              sx={{ color: "red", mt: 1, fontSize: "0.9rem" }}
            >
              {remarkError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "end", px: 3, py: 2 }}>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold" }}
            onClick={() => submitRemark()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* REPORTS POPUP DIALOG */}
      <Dialog
        open={openReportDialog}
        onClose={() => setOpenReportDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Reports
          <IconButton onClick={() => setOpenReportDialog(false)}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {loadingReportDialog ? (
            <Box sx={{ py: 5, display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
              <CircularProgress size={28} />
              <Typography sx={{ color: "#4b5563", fontWeight: 500 }}>
                Report data load ho raha hai...
              </Typography>
            </Box>
          ) : (
          <Box sx={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
              }}
            >
              <thead style={{ backgroundColor: "#f5f5f5" }}>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "10px" }}>Month</th>
                  <th style={{ border: "1px solid #ccc", padding: "10px" }}>
                    Current FY
                    <br />
                    {(toShortFY(financialYears.currentFY) || "Current FY")} Qty
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "10px" }}>
                    Previous FY
                    <br />
                    {(toShortFY(financialYears.previousFY) || "Previous FY")} Qty
                  </th>
                </tr>
              </thead>

              <tbody>
                {reportData.length > 0 ? (
                  reportData.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "10px",
                          textAlign: "left",
                          fontWeight: 600,
                        }}
                      >
                        {item.month}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                        {item.financialYear === financialYears.currentFY ? item.quantity : "-"}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
                        {item.financialYear === financialYears.previousFY ? item.quantity : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={3}
                      style={{
                        border: "1px solid #ccc",
                        padding: "15px",
                        textAlign: "center",
                        color: "gray",
                      }}
                    >
                      No report data available.
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </Box>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end", width: "auto" }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                fontWeight: "bold",
                px: 3,
                py: 1,
                minWidth: "100px",
                textTransform: "none",
              }}
              onClick={() => setOpenReportDialog(false)}
            >
              Close
            </Button>
          </Box>
        </DialogActions>

      </Dialog>

    </div>
  );
}

export default SampleSelection90days;
